query flowfactConfig($companyId: ID!) {
  flowfactConfig(companyId: $companyId) {
    token
    isTokenVerified
    selectedContactStatusIds
  }
}
